import { env } from '$env/dynamic/public';
import type { SendEmailRequest } from '$lib/types/sendEmailRequest';
import { HttpError } from '$lib/HttpError';

export class ContactUsApiClient {
  async sendEmail(request: SendEmailRequest) {
    const res = await fetch(`${env.PUBLIC_USER_SERVICE_BASE_URL}contact/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });

    if (!res.ok) {
      throw new HttpError(res.status);
    }
  }
}
